import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    quote:
      "Easy Compta a transformé ma façon de gérer ma boutique. Je comprends enfin mes finances sans avoir besoin d'un comptable !",
    name: 'Aminata Diallo',
    title: 'Propriétaire de boutique, Dakar',
    avatar:
      'https://plus.unsplash.com/premium_photo-1661589836910-b3b0bf644bd5?fm=jpg&q=60&w=300&ixlib=rb-4.1.0',
  },
  {
    quote:
      "Je prends en photo mes factures et tout se remplit tout seul. Plus besoin de tout retaper le soir après une longue journée.",
    name: 'Moussa Sarr',
    title: 'Chauffeur indépendant, Thiès',
    avatar:
      'https://media.istockphoto.com/id/1358424193/fr/photo/happy-smile-confidence-jeune-homme-chauffeur-de-camion-en-affaires-transport-long.jpg?s=150',
  },
  {
    quote:
      'Générer mes rapports PDF en un clic, c\'est magique ! Mes clients sont impressionnés par mon professionnalisme.',
    name: 'Fatou Ndiaye',
    title: 'Couturière, Saint-Louis',
    avatar:
      'https://media.istockphoto.com/id/1465634394/fr/photo/entrepreneur-africain-en-couture.jpg?s=150',
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const TestimonialsSection = () => {
  return (
    <section id="temoignages" className="lp-section lp-testimonials">
      <div className="lp-container">
        <header className="lp-section-header lp-reveal">
          <div className="lp-badge">
            <span className="lp-badge-dot" />
            Témoignages
          </div>
          <h2 className="lp-title">
            Ils nous font <span className="lp-title-accent">confiance</span>
          </h2>
          <p className="lp-subtitle lp-subtitle-center">
            Découvrez comment Easy Compta aide les entrepreneurs sénégalais au
            quotidien
          </p>
        </header>

        <motion.div
          className="lp-testimonials-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {testimonials.map((t) => (
            <motion.article
              key={t.name}
              className="lp-testimonial-card"
              variants={cardVariants}
            >
              <div className="lp-stars">★★★★★</div>
              <p className="lp-testimonial-quote">&ldquo;{t.quote}&rdquo;</p>
              <div className="lp-testimonial-author">
                <img src={t.avatar} alt={t.name} />
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.title}</span>
                </div>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
